import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { mergeMap, map, catchError } from 'rxjs/operators';
import { of, withLatestFrom } from 'rxjs';
import { Store } from '@ngrx/store';
import { FarmService } from '../_services';
import * as FarmActions from '../_actions/farm';
import { AppState } from '../_reducers';
import { selectCurrentFarm } from '../_selectors/currentFarm.selectors';
import { updateCurrentFarmSuccess } from '../_actions/currentFarm';

@Injectable({
  providedIn: 'root',
})
export class FarmEffects {
  loadFarms$ = createEffect(() =>
    this.actions$.pipe(
      ofType(FarmActions.loadFarms),
      mergeMap(() =>
        this.farmService.getList().pipe(
          map((farms) => FarmActions.loadFarmsSuccess({ farms })),
          catchError((error) => of(FarmActions.loadFarmsFailure({ error })))
        )
      )
    )
  );

  addFarm$ = createEffect(() =>
    this.actions$.pipe(
      ofType(FarmActions.addFarm),
      mergeMap(({ farm }) =>
        this.farmService.saveFarm(farm).pipe(
          map((savedFarm) => FarmActions.addFarmSuccess({ farm: savedFarm })),
          catchError((error) => of(FarmActions.addFarmFailure({ error })))
        )
      )
    )
  );

  updateFarm$ = createEffect(() =>
    this.actions$.pipe(
      ofType(FarmActions.updateFarm),
      mergeMap(({ farm }) =>
        this.farmService.saveFarm(farm).pipe(
          map((updatedFarm) => FarmActions.updateFarmSuccess({ farm: updatedFarm })),
          catchError((error) => of(FarmActions.updateFarmFailure({ error })))
        )
      )
    )
  );

  deleteFarm$ = createEffect(() =>
    this.actions$.pipe(
      ofType(FarmActions.deleteFarm),
      mergeMap(({ id }) =>
        this.farmService.deleteFarm(id).pipe(
          map(() => FarmActions.deleteFarmSuccess({ id })),
          catchError((error) => of(FarmActions.deleteFarmFailure({ error })))
        )
      )
    )
  );

  // Effetto per sincronizzare il currentFarm quando una farm viene aggiornata
  syncCurrentFarm$ = createEffect(() =>
    this.actions$.pipe(
      ofType(FarmActions.updateFarmSuccess), // Intercetta l'azione updateFarmSuccess
      withLatestFrom(this.store.select(selectCurrentFarm)), // Ottieni la farm corrente
      map(([action, currentFarm]) => {
        if (currentFarm?.id === action.farm.id) {
          // Se la farm aggiornata è la currentFarm, dispatcha l'azione per aggiornarla
          return updateCurrentFarmSuccess({
            farm: action.farm,
          });
        }
        return { type: '[CurrentFarm] No Action' }; // Nessuna azione se non è la currentFarm
      })
    )
  );

  constructor(
    private actions$: Actions,
    private farmService: FarmService,
    private store: Store<AppState>
  ) {}
}
